const hexToRgba = (hex, opacity = 0.5) => {
  if (
    !hex
    || hex.length !== 7
  ) {
    return hex;
  }

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  const r = parseInt(result[1], 16);
  const g = parseInt(result[2], 16);
  const b = parseInt(result[3], 16);

  return `rgb(${r} ${g} ${b} / ${opacity})`;
};

export default hexToRgba;
